import { RESPONSE_CHANGE_SELECTED_CAR, CLEAR_SELECTED_CARS } from "../actions/selectedCarsActions";

const initialState = {
  data: [],
};

const selectedCarsReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESPONSE_CHANGE_SELECTED_CAR: {
      return Object.assign({}, state, {
        data: action.data,
      });
    }
    case CLEAR_SELECTED_CARS:
      return Object.assign({}, state, initialState);
    default:
      return state;
  }
};

export default selectedCarsReducer;
